import s from "./ghl-ui.es1505.js";
import u from "./ghl-ui.es1506.js";
import a from "./ghl-ui.es1466.js";
function n(t, o) {
  a(2, arguments);
  var r = u(t), e = s(o);
  return r.setHours(e), r;
}
export {
  n as default
};
